var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargeBulletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9983 8.1976C29.3356 8.1976 28.7984 7.66128 28.7984 6.99968C28.7984 6.33809 29.3356 5.80176 29.9983 5.80176C30.661 5.80176 31.1982 6.33809 31.1982 6.99968C31.1982 7.66128 30.661 8.1976 29.9983 8.1976Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1985 8.19565C24.5358 8.19565 23.9986 7.65932 23.9986 6.99773C23.9986 6.33613 24.5358 5.7998 25.1985 5.7998C25.8612 5.7998 26.3984 6.33613 26.3984 6.99773C26.3984 7.65932 25.8612 8.19565 25.1985 8.19565Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3982 8.1937C19.7355 8.1937 19.1983 7.65737 19.1983 6.99577C19.1983 6.33418 19.7355 5.79785 20.3982 5.79785C21.0609 5.79785 21.5981 6.33418 21.5981 6.99577C21.5981 7.65737 21.0609 8.1937 20.3982 8.1937Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5989 8.18784C14.9362 8.18784 14.399 7.65151 14.399 6.98992C14.399 6.32832 14.9362 5.79199 15.5989 5.79199C16.2616 5.79199 16.7988 6.32832 16.7988 6.98992C16.7988 7.65151 16.2616 8.18784 15.5989 8.18784Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7991 8.17612C10.1364 8.17612 9.59916 7.63979 9.59916 6.9782C9.59916 6.3166 10.1364 5.78027 10.7991 5.78027C11.4618 5.78027 11.999 6.3166 11.999 6.9782C11.999 7.63979 11.4618 8.17612 10.7991 8.17612Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99977 8.17612C5.33707 8.17612 4.79984 7.63979 4.79984 6.9782C4.79984 6.3166 5.33707 5.78027 5.99977 5.78027C6.66248 5.78027 7.19971 6.3166 7.19971 6.9782C7.19971 7.63979 6.66248 8.17612 5.99977 8.17612Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7979 2.41635C34.1352 2.41635 33.5979 1.88003 33.5979 1.21843C33.5979 0.556836 34.1352 0.0205078 34.7979 0.0205078C35.4606 0.0205078 35.9978 0.556836 35.9978 1.21843C35.9978 1.88003 35.4606 2.41635 34.7979 2.41635Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9981 2.4144C29.3354 2.4144 28.7981 1.87807 28.7981 1.21648C28.7981 0.554883 29.3354 0.0185547 29.9981 0.0185547C30.6608 0.0185547 31.198 0.554883 31.198 1.21648C31.198 1.87807 30.6608 2.4144 29.9981 2.4144Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1987 2.41245C24.536 2.41245 23.9988 1.87612 23.9988 1.21452C23.9988 0.55293 24.536 0.0166016 25.1987 0.0166016C25.8615 0.0166016 26.3987 0.55293 26.3987 1.21452C26.3987 1.87612 25.8615 2.41245 25.1987 2.41245Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3985 2.40854C19.7358 2.40854 19.1985 1.87221 19.1985 1.21062C19.1985 0.549024 19.7358 0.0126953 20.3985 0.0126953C21.0612 0.0126953 21.5984 0.549024 21.5984 1.21062C21.5984 1.87221 21.0612 2.40854 20.3985 2.40854Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5987 2.39487C14.9359 2.39487 14.3987 1.85854 14.3987 1.19695C14.3987 0.535352 14.9359 -0.000976562 15.5987 -0.000976562C16.2614 -0.000976562 16.7986 0.535352 16.7986 1.19695C16.7986 1.85854 16.2614 2.39487 15.5987 2.39487Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7993 2.39487C10.1366 2.39487 9.5994 1.85854 9.5994 1.19695C9.5994 0.535352 10.1366 -0.000976562 10.7993 -0.000976562C11.462 -0.000976562 11.9993 0.535352 11.9993 1.19695C11.9993 1.85854 11.462 2.39487 10.7993 2.39487Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1985 14.0003C24.5358 14.0003 23.9986 13.464 23.9986 12.8024C23.9986 12.1408 24.5358 11.6045 25.1985 11.6045C25.8612 11.6045 26.3984 12.1408 26.3984 12.8024C26.3984 13.464 25.8612 14.0003 25.1985 14.0003Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3982 13.9964C19.7355 13.9964 19.1983 13.4601 19.1983 12.7985C19.1983 12.1369 19.7355 11.6006 20.3982 11.6006C21.0609 11.6006 21.5981 12.1369 21.5981 12.7985C21.5981 13.4601 21.0609 13.9964 20.3982 13.9964Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5989 13.9945C14.9362 13.9945 14.399 13.4582 14.399 12.7966C14.399 12.135 14.9362 11.5986 15.5989 11.5986C16.2616 11.5986 16.7988 12.135 16.7988 12.7966C16.7988 13.4582 16.2616 13.9945 15.5989 13.9945Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7991 13.9886C10.1364 13.9886 9.59916 13.4523 9.59916 12.7907C9.59916 12.1291 10.1364 11.5928 10.7991 11.5928C11.4618 11.5928 11.999 12.1291 11.999 12.7907C11.999 13.4523 11.4618 13.9886 10.7991 13.9886Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99977 13.9789C5.33707 13.9789 4.79984 13.4425 4.79984 12.7809C4.79984 12.1193 5.33707 11.583 5.99977 11.583C6.66248 11.583 7.19971 12.1193 7.19971 12.7809C7.19971 13.4425 6.66248 13.9789 5.99977 13.9789Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19997 13.9789C0.537264 13.9789 3.55244e-05 13.4425 3.55244e-05 12.7809C3.55244e-05 12.1193 0.537264 11.583 1.19997 11.583C1.86267 11.583 2.3999 12.1193 2.3999 12.7809C2.3999 13.4425 1.86267 13.9789 1.19997 13.9789Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeBulletIcon);
export default __webpack_public_path__ + "static/media/LargeBulletIcon.1002cfd5c5d1a6f794837828951e4199.svg";
export { ForwardRef as ReactComponent };